<template>
<div id="app" class="privacy-policy page-template-default page page-id-3 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="privacy" :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article id="post-3" class="post-3 page type-page status-publish">
            <div class="inside-article">
              <header class="entry-header section-content" aria-label="Content">
                <h1 class="entry-title" itemprop="headline">
                  Privacy Policy
                </h1>
              </header>

              <div class="section-content" itemprop="text">
                <p>
                  Welcome to <strong>GB-DWNPlus.org（our website）</strong>. Your privacy is important to us. This Privacy Policy explains how we handle user information when you visit our website.
                </p>
                
                <h2>Information We Collect</h2>
                <p>
                  We do <strong>not</strong> collect any personally identifiable information from our visitors. You can browse all pages of GB-DWNPlus.org without providing any personal data such as name, email, or phone number.
                </p>

                <h2>Cookies and Analytics</h2>
                <p>
                  Our website may use cookies or third-party analytics tools (such as Google Analytics) to understand site traffic and improve user experience. These cookies do not collect personal information and can be disabled in your browser settings at any time.
                </p>

                <h2>External Links</h2>
                <p>
                  GB-DWNPlus.org may contain links to third-party websites for informational or reference purposes. We have no control over the content or privacy practices of those external sites, and we encourage you to review their respective privacy policies before interacting with them.
                </p>

                <h2>Information Use</h2>
                <p>
                  Any non-personal data collected through analytics or cookies is used solely to improve site functionality, enhance content quality, and understand user preferences. We do not sell, trade, or share any user information with third parties.
                </p>

                <h2>Children's Privacy</h2>
                <p>
                  Our website is intended for general audiences and is not directed toward children under 13. We do not knowingly collect personal information from minors.
                </p>

                <h2>Updates to This Policy</h2>
                <p>
                  We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Any updates will be posted on this page with a revised "Last updated" date.
                </p>
              </div>

              <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Privacy',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'privacy',

      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color: #333;
  position: relative;
  padding-left: 20px;
}

h1::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

h2 {
  font-size: 2rem;
  font-weight: bold;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  color: #333;
  position: relative;
  padding-left: 20px;
}

h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
  position: relative;
  padding-left: 15px;
}

h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

.section-content p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #555;
}

#maincontent {
  margin-top: 22px !important;
}

@media (max-width: 768px) {
  h1 {
    font-size: 2rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
  
  h3 {
    font-size: 1.2rem;
  }
}
</style>
